import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { theme } from "../../styles/theme";
import { Modal } from "../ui/Modal";
import { Button } from "../ui/Button";
import { Label, ErrorMessage } from "../ui/Input";
import { renderProject } from "../../services/api";

const Layout = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.lg};
`;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 140px;
  padding: ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.md};
  border: ${theme.borders.base};
  font-family: inherit;
  resize: vertical;
`;

const ActionRow = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  flex-wrap: nowrap;
  justify-content: flex-end;
`;

function RenderDialog({ isOpen, project, onClose, onModify }) {
  const [prompt, setPrompt] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [quality, setQuality] = useState("default");

  useEffect(() => {
    if (isOpen && project) {
      const base = project.video_prompt || "";
      const appended = `${base}${base ? "\n\n" : ""}The person is not talking`;
      setPrompt(appended);
      setError("");
      setQuality("default");
    }
  }, [isOpen, project]);

  if (!project) return null;

  const handleRender = async (event) => {
    event.preventDefault();
    if (!prompt.trim()) {
      setError("Prompt cannot be empty");
      return;
    }

    setLoading(true);
    setError("");
    onClose?.();
    renderProject(project.id, prompt.trim(), quality)
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("Failed to start render", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal isOpen={isOpen} onClose={loading ? undefined : onClose}>
      <Layout onSubmit={handleRender}>
        <div>
          <Label htmlFor="render-prompt">Video prompt</Label>
          <TextArea
            id="render-prompt"
            value={prompt}
            onChange={(event) => setPrompt(event.target.value)}
            disabled={loading}
            rows={5}
          />
          {error && <ErrorMessage>{error}</ErrorMessage>}
        </div>

        <div>
          <Label htmlFor="render-quality">Quality</Label>
          <select
            id="render-quality"
            value={quality}
            onChange={(e) => setQuality(e.target.value)}
            disabled={loading}
            style={{
              padding: theme.spacing.sm,
              borderRadius: theme.borderRadius.md,
              border: theme.borders.base,
              width: "100%",
            }}
          >
            <option value="default">DEFAULT (grok imagine video)</option>
            <option value="fast">FAST (veo 3.1 fast)</option>
            <option value="pro">PRO (veo 3.1)</option>
          </select>
        </div>

        <ActionRow>
          <Button type="button" variant="ghost" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            type="button"
            variant="secondary"
            onClick={() => {
              if (onModify) {
                onClose?.();
                onModify(project);
              }
            }}
            disabled={loading}
          >
            Modify
          </Button>
          <Button type="submit" disabled={loading}>
            {loading ? "Starting..." : "Render video"}
          </Button>
        </ActionRow>
      </Layout>
    </Modal>
  );
}

export default RenderDialog;
